import { render, staticRenderFns } from "./myCard.vue?vue&type=template&id=00643166&scoped=true"
import script from "./myCard.vue?vue&type=script&lang=js"
export * from "./myCard.vue?vue&type=script&lang=js"
import style0 from "./myCard.vue?vue&type=style&index=0&id=00643166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00643166",
  null
  
)

export default component.exports